import { ReallyClickDirective } from './really-click.directive';

export { ReallyClickDirective };


// WEBPACK FOOTER //
// ./src/app/directives/index.ts